// client/src/coms/components/sidebar_parts/SidebarHeader.js
import React from 'react';
import ServerEncryptionBadge from '../../e2ee/ServerEncryptionBadge';

// The logo and name open the server overview when the sidebar provides one.
function Opener({ onOpen, name, children }) {
  if (typeof onOpen !== 'function') return children;
  return (
    <button type="button" className="vx-sh-open" onClick={onOpen} title={`${name}: server overview`} aria-label={`${name}: open server overview`} data-testid="open-server-overview">
      {children}
    </button>
  );
}

export function SidebarHeader({
  server,
  isMobileViewport,
  hasServerLogo,
  serverLogoUrl,
  serverAcronym,
  onLogoError,
  onOpenOverview = null,
}) {
  return (
    <div className="coms-sidebar-top" style={isMobileViewport ? { flexShrink: 0 } : undefined}>
      <div
        style={{
          width: '100%',
          height: 1,
          background: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.10 * var(--vx-ov, 1)))',
        }}
      />

      <div
        style={{
          width: '100%',
          padding: '10px 10px 2px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <Opener onOpen={onOpenOverview} name={server && server.name ? String(server.name) : 'Server'}>
        <div
          title={server && server.name ? String(server.name) : 'Server'}
          style={{
            width: 56,
            height: 56,
            borderRadius: 999,
            overflow: 'hidden',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.06 * var(--vx-ov, 1)))',
            border: '1px solid rgba(var(--vx-fg-rgb, 255,255,255), calc(0.12 * var(--vx-ov, 1)))',
            boxShadow: '0 8px 22px rgba(0,0,0,0.25)',
            flex: '0 0 auto',
            userSelect: 'none',
          }}
        >
          {hasServerLogo ? (
            <>
              <div
                aria-hidden="true"
                style={{
                  position: 'absolute',
                  inset: 0,
                  backgroundImage: `url("${serverLogoUrl}")`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              />
              <div
                aria-hidden="true"
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to top, rgba(0,0,0,0.22), rgba(0,0,0,0.06))',
                  pointerEvents: 'none',
                }}
              />
            </>
          ) : (
            <span
              style={{
                position: 'relative',
                zIndex: 1,
                fontSize: 14,
                fontWeight: 900,
                letterSpacing: '0.04em',
                color: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.95 * var(--vx-ov, 1)))',
                lineHeight: 1,
                padding: '0 6px',
                textAlign: 'center',
              }}
            >
              {serverAcronym}
            </span>
          )}
        </div>

        <div
          style={{
            width: '100%',
            textAlign: 'center',
            fontWeight: 800,
            fontSize: 14,
            letterSpacing: 0.2,
            padding: '0 10px 6px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            opacity: 0.95,
          }}
          title={server && server.name ? String(server.name) : ''}
        >
          {server && server.name ? String(server.name) : ''}
        </div>
        </Opener>
        {server && server.id ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <ServerEncryptionBadge serverKey={server.public_id || server.id} />
          </div>
        ) : null}
      </div>
    </div>
  );
}